import { Project } from './../../../shared/models/project';
export class ProjectCreate {
  CreatedProject: Project;
  WellId?: number;
  AssetId?: number;
  DrillDesignId?: number;
  DrillGroupId?: number;
  DefaultStandardConfigurationId?: number;
  AllocatedAssets?: Array<number>;
  AdditionalDrillGroups?: Array<number>;
  TankBatteryAssetId?: number;
  PadAssetId?: number;
  ReturnAsArray: boolean = false;

  constructor(item?: any) {
    this.CreatedProject = item.CreatedProject;
    this.WellId = item.WellId;
    this.AssetId = item.AssetId;
    this.DrillDesignId = item.DrillDesignId;
    this.DrillGroupId = item.DrillGroupId;
    this.DefaultStandardConfigurationId = item.DefaultStandardConfigurationId;
    this.AllocatedAssets = item.AllocatedAssets;
    this.TankBatteryAssetId = item.TankBatteryAssetId;
    this.PadAssetId = item.PadAssetId;
    this.ReturnAsArray = item.ReturnAsArray;
    this.AdditionalDrillGroups = item.AdditionalDrillGroups;
  }
}